import { useLazyQuery } from '@apollo/client';
import { useEntity } from '@avangard/utils/entity';

import { LapEntityList } from '@modules/lap/entities';
import { GetLapCollectionQuery } from '@modules/lap/graphql';

import type { QueryLazyOptions, LazyQueryResult, QueryHookOptions } from '@apollo/client';
import type { LapEntity } from '@modules/lap/entities';
import type {
    GetLapCollectionQueryType,
    GetLapCollectionQueryVariables,
} from '@modules/types/graphql';

type Tuple = [
    (options?: QueryLazyOptions<GetLapCollectionQueryVariables>) => void,
    LazyQueryResult<GetLapCollectionQueryType, GetLapCollectionQueryVariables> & {
        laps: LapEntity[];
        count: number;
    },
];

const useLazyLapsCollection = (
    options?: QueryHookOptions<GetLapCollectionQueryType, GetLapCollectionQueryVariables>,
): Tuple => {
    const [getLapsCollection, queryResult] = useLazyQuery<
        GetLapCollectionQueryType,
        GetLapCollectionQueryVariables
    >(GetLapCollectionQuery, options);

    const { entities: laps, count } = useEntity(
        () => new LapEntityList(queryResult.data?.getLapCollection?.items ?? []),
        [queryResult.data],
    );

    return [getLapsCollection, { laps, count, ...queryResult }];
};

export { useLazyLapsCollection };
